/**
 * Escape single and double quotes in a string.
 *
 * @param {string} string
 * @returns {string}
 */
export default function (string) {
    return string.replace(/"/g, '\\"').replace(/'/g, "\\'");
}
